import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from '@ipc/ipc-core';

const AppHeaderLeftContainer = () => (
  <div className="header-left-container">
    <div className="app-title">
      <Link to={{ pathname: '/application-type' }}>
        <FormattedMessage id="app.title" tagName="h1" />
      </Link>
    </div>
  </div>
);

export default AppHeaderLeftContainer;
